import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { v4 as uuidv4 } from "uuid";
import { isEmpty } from "js/common";

// setSearchDisabled : StateSetter. 검색버튼이 있는 경우 설정. 정확한 날짜가 입력되지 않으면 true. 값이 아예 없거나 정확히 입력되면 false.
// tableDivRef : Ref. table내부에 위치하는 경우, table상위의 DIV가 좌우 Scroll이 있는 경우 설정. 스크롤 되는 경우 달력의 위치를 다시 설정하기 위함.
// type: YEAR or MONTH or DAY (default)
// export default function DatePickerInput({ name, value, style, onClick, onChange, type = "DAY", setSearchDisabled = null, positionCalc = true, required = false }) {
export default function DatePickerInput({ name, value = "", initialValue, style, onChange, type = "DAY", setSearchDisabled = null, positionCalc = true, required = false, onKeyDown }) {
    const [isCalendarVisible, setIsCalendarVisible] = useState(false);
    const datePickerRef = useRef(null);
    const calendarRef = useRef(null);
	const [isValidDate, setIsValidDate] = useState(false);
	const dateInput = useRef(null);
	const calendarDiv = useRef();

	const [calDate, setCalDate] = useState("");
	const [cursorPosition, setCursorPosition] = useState(-1);
	const [initialDate, setInitialDate] = useState(new Date());


    const handleOutsideClick = (event) => {
		if(!datePickerRef.current.contains(event.target)) {
			setIsCalendarVisible(false);
		}
    };

    const handleEscPress = (event) => {
        if (event?.key?.toLowerCase() === "escape") {
            setIsCalendarVisible(false);
        }
    };


    useEffect(() => {
        // 다른 곳 클릭 시 닫음
        document.addEventListener("click", handleOutsideClick, true);
        document.addEventListener("keydown", handleEscPress, true);
        return () => {
			document.removeEventListener("click", handleOutsideClick, true);
            document.removeEventListener("keydown", handleEscPress, true);
        };
    }, []);

	// initialValue 변경시 initialDate 설정
	useEffect(() => {
		const date = new Date(initialValue);
		if(!isNaN(date.getTime())) {
			// 날짜 맞음
			setInitialDate(date);
		}
	}, [initialValue]);

    const onClickDate = (data) => {
		const formatData = formatChange(data);
        setIsCalendarVisible(false);	// 달력 숨기기
		checkValidAction(formatData);	// 날짜 valid에 따른 처리.
    };

    const formatChange = (date) => {
		if(type === "YEAR") {
			return date.getFullYear().toString();
		} else if(type === "MONTH") {
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0");
			const formatted = `${year}-${month}`;
			return formatted;
		} else {
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0");
			const day = date.getDate().toString().padStart(2, "0");
			const formatted = `${year}-${month}-${day}`;
			return formatted;
		}
    };
	

	// 입력값을 날짜형태로 변환
	const dateInputChange = (e) => {
        // const { value, name } = e.target;
		const inputVal = e.target.value;

		let validLen = -1;
		if(type === "YEAR") validLen = 4;
		else if(type === "MONTH") validLen = 6;
		else validLen = 8;

		if(inputVal.replace(/-/g, "").length > validLen) {
			// hyphen이 지워진 상태에서 숫자를 입력하면 밀리거나 커서가 맨뒤로 가는 현상 수정.
			const newPosition = value.length - cursorPosition;
			setDateInputCursorPosition(newPosition);
			return;
		}
		const selectionStart = e.target.selectionStart;

		let curPosition = inputVal.length - e.target.selectionStart	// 커서 위치. 뒤에서부터 계산
		setCursorPosition(curPosition);

		let formatVal = inputVal;
		if(inputVal.replace(/-/g, "") === value.replace(/-/g, "")) {
			// hyphen 지운것. 여기서 다시 계산하면 hyphen이 안지워짐. 그리고 커서는 맨 뒤로..
		} else {
			formatVal = strFormatDate(inputVal);	// 입력값을 날짜 format으로 변경
			e.target.value = formatVal;
		}

		if(inputVal.length !== formatVal.length) {
			// hyphen이 생기거나 삭제 되면서 cursor 위치가 변경됨
			// hyphen 개수가 다르면 커서 위치를 조절.
			const adjustPoint = formatVal.substring(selectionStart).split("-").length - inputVal.substring(selectionStart).split("-").length;
			setCursorPosition(curPosition + adjustPoint);
		}

		onChange && onChange(e);	// 위로 전달. 그래야 입력값이 화면에 표시됨.
		
		checkValidAction(formatVal);
	}

	const onBlur = (e) => {
		const inputVal = e.target.value;
		// focus 나가면 format 처리
		const formatVal = strFormatDate(inputVal);	// 입력값을 날짜 format으로 변경
		e.target.value = formatVal;
		checkValidAction(formatVal);
	}

	const strFormatDate = (value, formatType = type) => {
		let formatVal = value.replace(/[^0-9]/g, '');
		let validLen = -1;
		
		if(formatType === "YEAR") validLen = 4;
		else if(formatType === "MONTH") validLen = 6;
		else validLen = 8;

		if(formatVal.length > validLen) formatVal = formatVal.substring(0, validLen);
		
		if(formatVal.length === validLen) {
			// 날짜로 형변환해서 정상적인 날짜가 아니어도 정상적으로 변환되도록...
			formatVal = makeNormalDate(formatVal);
		}

		if(formatVal.length <= 4) {
			// nothing todo
		} else if(formatVal.length <= 6) {
			formatVal = formatVal.replace(/(\d{4})(\d)/g, '$1-$2');
		} else {
			formatVal = formatVal.replace(/(\d{4})(\d{2})(\d)/g, '$1-$2-$3');
		}

		return formatVal;

	}

	// 달력용 날짜 만들기. 입력값을 그대로 넣으면 날짜가 올바르지 않아서 문제가 생김.
	const makeCalendarDate = (value) => {
		if(!value || value === "") {
			setCalDate("");
			return;
		}
		let formatVal = value.replace(/[^0-9]/g, '');
		if(formatVal.length > 8) formatVal = formatVal.substring(0, 8);
		let year = "", month = "", date = "";
		if(formatVal.length <= 4) {
			year = formatVal;
			month = "01";
			date = "01";
		} else if(formatVal.length <= 6) {
			year = formatVal.substring(0, 4);
			month = formatVal.substring(4)
			date = "01";
		} else {
			year = formatVal.substring(0, 4);
			month = formatVal.substring(4, 6);
			date = formatVal.substring(6);
		}

		if(year.length <= 2) {
			// 연도가 2자리 이하면 앞에 20을 붙여줌.
			year = "20" + year.padStart(2, "0");
		}
		if(month === "0" || month === "00") {
			// 월이 0이면 1월로 세팅
			month = "01";
		}
		if(date === "0" || date === "00") {
			// 일이 0이면 1일로 세팅
			date = "01";
		}
		
		// 월/일은 앞에 0붙여서 2자리로 만들기
		formatVal = year + month.padStart(2, "0") + date.padStart(2, "0");

		// 날짜형으로 변환해서 정상적인 날짜로 만들기
		formatVal = makeNormalDate(formatVal, "DAY");	// DAY를 넣어서 완전한 날짜 형태로 생성. 그래야 달력에서 정상 표시.
		// 하이픈 넣어서 날짜 format생성
		formatVal = formatVal.replace(/(\d{4})(\d{2})(\d)/g, '$1-$2-$3');
		setCalDate(formatVal);
	}

	// 문자열 형태의 날짜를 date로 형변환해서 정상적인 날짜형태로 변환
	const makeNormalDate = (date, formatType = type) => {
		let tmp = new Date(1,0,1);	// 1901년 1월 1일로 기본 세팅
		tmp.setFullYear(date.substring(0, 4));
		if(formatType !== "YEAR") {
			tmp.setMonth(date.substring(4,6)*1-1);
			if(formatType !== "MONTH") {
				tmp.setDate(date.substring(6,8));
			}
		}


		if(formatType === "YEAR") {
			return tmp.getFullYear().toString()	
		} else if(formatType === "MONTH") {
			return tmp.getFullYear().toString() + (tmp.getMonth()+1).toString().padStart(2, "0")	
		} else {
			return tmp.getFullYear().toString() + (tmp.getMonth()+1).toString().padStart(2, "0") + tmp.getDate().toString().padStart(2, "0");
		}
		
	}

	const checkFormatDate = (formatVal) => {
		let validLen = -1;
		if(type === "YEAR") validLen = 4;
		else if(type === "MONTH") validLen = 7;
		else validLen = 10;

		if(isEmpty(formatVal) || formatVal.length === validLen) {
			return true;
		} else {
			return false;
		}
	}

	// 날짜 valid여부에 따른 action
	const checkValidAction = (formatVal, onlyCheck = false) => {
		if(required && (isEmpty(formatVal))) {
			setIsValidDate(false);
			// 필수인데 값이 없으면 비활성
			setSearchDisabled && setSearchDisabled(true);	// 검색버튼이 있으면 검색버튼 비활설화
			!setSearchDisabled && (dateInput.current.style.color = "red");	// 검색버튼이 없으면 글자색 빨강
		} else if(checkFormatDate(formatVal)) {
			setIsValidDate(true);
			// 데이터가 없거나 정상 날짜인 경우.
			setSearchDisabled && setSearchDisabled(false);	// 검색버튼이 있으면 검색버튼 활성화
			!setSearchDisabled && (dateInput.current.style.color = "");	// 검색버튼 없으면 글자색 제거
			// onClick && onClick(formatVal);
			if(onChange && !onlyCheck) {
				const target = dateInput.current;
				target.value = formatVal;
				onChange({target: target});
			}
		} else {
			setIsValidDate(false);
			// 데이터가 있는데 비정상 날짜인 경우
			setSearchDisabled && setSearchDisabled(true);	// 검색버튼이 있으면 검색버튼 비활설화
			!setSearchDisabled && (dateInput.current.style.color = "red");	// 검색버튼이 없으면 글자색 빨강
		}
	}

	useEffect(() => {
		// 상위의 테이블(정확히는 테이블을 감싸는 DIV)이 scroll이 있으면 스크롤 했을때 달력의 위치가 이상해짐.
		// 달력이 보여질때 위치를 계산해서 다시 설정.
		if(positionCalc && isCalendarVisible) {
			let dom = calendarDiv.current;
			let calTop = null;
			let calLeft = null;
			while(true) {
				dom = dom.parentElement ? dom.parentElement : null;
				if(dom === null || dom.tagName.toLowerCase() === "html") break;

				if(calTop === null && dom?.scrollTop && dom.scrollTop > 0) {
					calTop = (getComputedStyle(calendarDiv.current).top.replace("px", "")) * 1 - dom.scrollTop;
				}
				if(calLeft === null && dom?.scrollLeft && dom?.scrollLeft > 0) {
					calLeft = (getComputedStyle(calendarDiv.current).left.replace("px", "")) * 1 - dom.scrollLeft;
				}
				if(calTop !== null && calLeft !== null) break;
			}
			if(calTop !== null) {
				calendarDiv.current.style.top = calTop + "px";
			}
			if(calLeft !== null) {
				calendarDiv.current.style.left = calLeft + "px";
			}
		}

	}, [isCalendarVisible])

	useEffect(() => {
		makeCalendarDate(value);
		checkValidAction(value, true);
		const newPosition = dateInput.current.value.length - cursorPosition;
		setDateInputCursorPosition(newPosition);
		// value && checkValidAction(value, true);
	}, [value]);
	
	// 커서 위치 설정
	const setDateInputCursorPosition = (position) => {
		setTimeout(function() {
			// 원래 커서 포지션으로 이동
			dateInput.current?.setSelectionRange(position, position);
		}, 1);	// 왜인지 setTimeout으로 걸어줘야 정상 동작
	}

	const onInputKeyDown = (e) => {
		if(onKeyDown && isValidDate) {
			onKeyDown(e);
		}
	}

	useEffect(() => {
		if(isCalendarVisible) {
			// 달력이 화면 크기를 넘어가면, 차이만큼 marginLeft를 줘서 넘어가지 않도록 조정.
			if(document.body.clientWidth < calendarDiv.current.getBoundingClientRect().right) {
				let gap = document.body.clientWidth - calendarDiv.current.getBoundingClientRect().right;
				calendarDiv.current.style.marginLeft = gap + "px";
			}
		}
	}, [isCalendarVisible]);

    return (
        <div ref={datePickerRef} style={ style } >
			<div  style={{ display: "flex" }}>
				<input
					ref={dateInput}
					autoComplete="off"
					id={uuidv4()}
					type="text"
					name={name}
					value={value || ""}
					onChange={(e) => dateInputChange(e)}
					onBlur={onBlur}
					maxLength={10}
					className="basic-input"
					// onKeyDown={onKeyDown && isValidDate && (e => onKeyDown(e))}
					onKeyDown={onInputKeyDown}
					inputMode="numeric"
				/>
				<div className="div_btn_dayPicker">
					<button onClick={() => setIsCalendarVisible(!isCalendarVisible)} className="btn_dayPicker"></button>
				</div>
			</div>

            {isCalendarVisible && (
                // <div ref={calendarRef} id={uuidv4()} style={{position: "relative"}}>
                <div ref={calendarRef} id={uuidv4()} >
					<div style={{ position: "absolute", width: "350px" }} ref={calendarDiv}>
                    	<Calendar
							value={calDate}
							maxDetail={type === "YEAR" ? "decade" : type === "MONTH" ? "year" : "month"}
							onClickDay={e => onClickDate(e)}
							onClickMonth={e => type === "MONTH" ? onClickDate(e) : null}
							onClickYear={e => type === "YEAR" ? onClickDate(e) : null}
							calendarType="gregory"
							formatDay={(locale, date) => date.getDate()}
							tileClassName={({date}) => type === "DAY" && date.getDay() === 6 ? "saturday" : ""}	// 토요일은 파란색으로 처리
							defaultActiveStartDate={calDate === null || calDate === "" ? initialDate : null}
						/>
					</div>
                </div>
            )}
        </div>
    );
}
